import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useLanguage } from '../../i18n/LanguageContext';

const LegalLayout = ({ user, setUser, titleKey, titleFallback, subtitleKey, subtitleFallback, lastUpdated, children, testId, esTitle, esSubtitle }) => {
  const { t, lang } = useLanguage();
  const title = lang === 'es' && esTitle ? esTitle : (titleKey ? t(titleKey, titleFallback) : titleFallback);
  const subtitle = lang === 'es' && esSubtitle ? esSubtitle : (subtitleKey ? t(subtitleKey, subtitleFallback) : subtitleFallback);
  const lastUpdatedLabel = t('legal.lastUpdated', 'Last updated:');
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header user={user} setUser={setUser} />
      <main className="flex-1 px-6 md:px-12 lg:px-16 py-16">
        <article className="max-w-3xl mx-auto" data-testid={testId}>
          <div className="mb-10">
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-text-primary mb-3">{title}</h1>
            {subtitle && <p className="text-lg text-text-secondary mb-2">{subtitle}</p>}
            {lastUpdated && (
              <p className="text-sm text-text-secondary italic">{lastUpdatedLabel} {lastUpdated}</p>
            )}
          </div>
          <div className="prose prose-stone max-w-none [&_h2]:font-heading [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-text-primary [&_h2]:mt-10 [&_h2]:mb-4 [&_h3]:font-heading [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-text-primary [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:text-text-secondary [&_p]:leading-relaxed [&_p]:mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4 [&_ul]:space-y-2 [&_ul]:text-text-secondary [&_li]:leading-relaxed [&_strong]:text-text-primary">
            {typeof children === 'function' ? children(lang) : children}
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default LegalLayout;
